import React, { Component } from "react";
import { connect } from "react-redux";
import { setSCQResponse, validateSCQ } from "actions";

import "./SingleChoiceQuestion.scss";

import { withTranslation } from "react-i18next";
import {
  Log,
  LogEvent,
} from "@learningblocks/shared-components/lib/EventLogger";

class SCQ extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  handleRadioChange = (e) => {
    this.props.setSCQResponse({
      id: this.props.id,
      index: e.target.value,
      checked: !this.props.choices[e.target.value].checked,
    });
  };

  handleRadioChangeKey = (e) => {
    this.props.setSCQResponse({
      id: this.props.id,
      index: e.target.previousSibling.value,
      checked: !this.props.choices[e.target.previousSibling.value].checked,
    });
  };

  validateSCQ = () => {
    this.props.validateSCQ({ id: this.props.id });
  };

  componentDidUpdate(prevProps) {
    if (this.props.correct !== prevProps.correct) {
      this.answered.focus();
    }
  }

  render() {
    const questionIndex = this.props.index;

    return (
      <div className="singleChoiceQuestion">
        <Log question_number={this.props.id}>
          <p
            className="label"
            aria-label={
              this.props.t("Question") +
              " " +
              this.props.t(this.props.index + 1) +
              ". " +
              this.props.t(this.props.label)
            }
          >
            {this.props.t(this.props.index + 1) +
              ". " +
              this.props.t(this.props.label)}
          </p>

          {this.props.choices.map((option, index) => (
            <div className="input" key={index}>
              <LogEvent
                logEventProps={{
                  event_type: "sim_singlechoicequestion_option selected",
                  event_schema: "singlechoice",
                  options: [String.fromCharCode(97 + index)],
                }}
                actionProps={
                  !this.props.disabled && !this.props.complete
                    ? { onClick: { action: "clicked" } }
                    : null
                }
                elementType="div"
              >
                <input
                  id={"scq" + questionIndex + index}
                  className={
                    option.correct == null
                      ? ""
                      : option.correct
                        ? "correct"
                        : "incorrect"
                  }
                  type="radio"
                  name={"answer" + this.props.index}
                  value={index}
                  onClick={this.handleRadioChange}
                  defaultChecked={option.checked}
                  tabIndex={-1}
                  disabled={
                    (this.props.attempts > 0 ||
                      this.props.attempts === "unlimited") &&
                    (this.props.correct === false ||
                      this.props.correct == null ||
                      this.props.attempts === "unlimited")
                      ? false
                      : true
                  }
                />
                {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
                <label
                  ref={
                    option.checked
                      ? (answered) => {
                          this.answered = answered;
                        }
                      : null
                  }
                  onKeyDown={(e) => {
                    if (e.keyCode === 13 || e.keyCode === 32)
                      this.handleRadioChangeKey(e);
                  }}
                  htmlFor={"scq" + questionIndex + index}
                  className="response"
                  aria-label={
                    this.props.t(option.checked ? "selected, " : "") +
                    (option.correct !== null
                      ? option.correct === true
                        ? this.props.t("correct, ")
                        : this.props.t("incorrect, ")
                      : "") +
                    String.fromCharCode(97 + index) +
                    ", " +
                    this.props.t(option.label)
                  }
                >
                  <span aria-hidden="true" className="checkmark">
                    {String.fromCharCode(97 + index).toUpperCase()}
                  </span>
                  {this.props.t(option.label)}
                </label>
                <div className="feedback">
                  <p>
                    {option.correct == null
                      ? ""
                      : !option.correct
                        ? this.props.t("Feedback:") +
                          " " +
                          this.props.t(option.feedback)
                        : ""}
                  </p>
                </div>
              </LogEvent>
            </div>
          ))}
          <div className="question-footer">
            <p>
              {this.props.t("Attempts left:") +
                " " +
                this.props.t(this.props.attempts)}
            </p>
            <LogEvent
              logEventProps={{
                event_type: "sim_singlechoicequestion submitted",
                event_schema: "singlechoice",
                options: this.props.choices
                  .map((option, index) => {
                    return { ...option, index: index };
                  })
                  .filter(
                    (option) =>
                      option.checked === true && option.correct === null
                  )
                  .map((option) => String.fromCharCode(97 + option.index)),
                correct:
                  this.props.choices.filter((option, index) => {
                    return option.checked && index + 1 === this.props.answer;
                  }).length > 0,
              }}
              actionProps={{ onClick: { action: "click" } }}
              elementType="button"
            >
              <button
                onClick={this.validateSCQ}
                disabled={
                  (this.props.attempts > 0 ||
                    this.props.attempts === "unlimited") &&
                  (this.props.correct === false ||
                    this.props.correct === null ||
                    this.props.attempts === "unlimited") &&
                  this.props.anyResponse
                    ? false
                    : true
                }
              >
                {this.props.t("Submit answer")}
              </button>
            </LogEvent>
          </div>
        </Log>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    id: ownProps.id,
    choices: state.SCQ.SCQs[ownProps.id - 1].choices,
    label: state.SCQ.SCQs[ownProps.id - 1].label,
    attempts: state.SCQ.SCQs[ownProps.id - 1].attempts,
    answer: state.SCQ.SCQs[ownProps.id - 1].answer,
    response: state.SCQ.SCQs[ownProps.id - 1].response,
    correct: state.SCQ.SCQs[ownProps.id - 1].correct,
    anyResponse: state.SCQ.SCQs[ownProps.id - 1].anyResponse,
    image: state.SCQ.SCQs[ownProps.id - 1].image,
  };
};

export default connect(mapStateToProps, {
  setSCQResponse,
  validateSCQ,
})(withTranslation()(SCQ));
